import React from "react";

import { Trans, withTranslation } from "react-i18next";
import Bonification from "./Bonification";
import { Profil } from "./Profil";
import { Vendor } from "./Vendor";
import { Tag, Label } from "@blueprintjs/core";
import { 
  parkLookupDiscount,
  getDiscountLookup, 
  serverLookupDiscount, 
  getCronDateLookup, 
  getVendorLookup, 
  getProfilLookup 
} from './lookup';


function BonificationManager() {
  const [parks, setParks] = React.useState([]);
  const [sites, setSites] = React.useState([]);
  const [key, setKey] = React.useState(Date.now());
  const [vendors, setVendors] = React.useState([]);
  const [profils, setProfils] = React.useState([]);
  const [discounts, setDiscounts] = React.useState([]);
  const [cronDate, setCronDate] = React.useState(undefined);

  React.useEffect(() => {
    const fetchData = async () => {
      const parksBack = await parkLookupDiscount();
      const sitesBack = await serverLookupDiscount();
      const discountsBack = await getDiscountLookup();
      const vendorsBack = await getVendorLookup();
      const profilsBack = await getProfilLookup();
      const cronDateBack = await getCronDateLookup();

      setParks(parksBack);
      setSites(sitesBack);
      setDiscounts(discountsBack);
      setVendors(vendorsBack);
      setProfils(profilsBack);
      setCronDate(cronDateBack);
    }
    fetchData();
    return function () {
      //code to be run during unmount phase
      localStorage.removeItem('bonitickToken');
      localStorage.removeItem('vendorLookup');
      localStorage.removeItem('profilLookup');
      localStorage.removeItem('parkLookupDiscount');
      localStorage.removeItem('discountLookup');
    }
  }, []);

  const profileUpdated = async () => {
    const vendorsBack = await getVendorLookup();
    const profilsBack = await getProfilLookup();
    setVendors(vendorsBack);
    setProfils(profilsBack);
    setKey(Date.now());
  }


  return (parks.length > 0 && sites.length > 0) ?
      <div className="component-body">
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
          {cronDate && <p><Trans>last bonitick synchronisation</Trans>: <Tag>{cronDate}</Tag></p>}
        </div>
        <Bonification parks={parks} sites={sites} discounts={discounts} />
        <Profil updated={profileUpdated} />
        <Vendor vendors={vendors} profils={profils} key={key} />
      </div >
      :
      <div className="component-body">
       <Label htmlFor="endDate"><Trans>You must have at least 1 park and 1 site</Trans></Label>
      </div >
  ;
  
}

export default withTranslation()(BonificationManager);
